import { Link as LinkLi } from '@material-ui/core';
import { ArrowForwardIos } from '@material-ui/icons';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';


const ArrowForward = styled(ArrowForwardIos)`
      font-size: 75% !important;
`; 

const SubHeader = ({ text, className, Container, to, ...rest }) => {
  if (to) {
    return (
      <>
        <LinkLi component={Link} to={to}>
          <Container hoverEffect className={`${className || ''}`} {...rest} to={to}>
            {text}
            <ArrowForward />
          </Container>
        </LinkLi>
      </>
    );
  }
  return (
    <Container className={className || ''} {...rest}>
      {text}
    </Container>
  );
};

export default SubHeader;
